import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, CheckCircle, AlertCircle, Users, Shield } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="section-padding">
        <div className="container-custom max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
              <FileText className="w-4 h-4 mr-2" />
              Términos y Condiciones
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Términos de
              <span className="text-gradient"> Servicio</span>
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Al utilizar nuestros servicios, usted acepta estos términos y condiciones 
              que rigen nuestra relación comercial.
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
            <section>
              <div className="flex items-center mb-4">
                <CheckCircle className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">1. Aceptación de Términos</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Al utilizar nuestro sitio web y servicios, usted acepta estos términos y condiciones 
                en su totalidad. Si no está de acuerdo con alguno de estos términos, 
                por favor no utilice nuestros servicios.
              </p>
              <div className="bg-blue-50 rounded-lg p-6">
                <h3 className="font-semibold text-blue-900 mb-3">El uso de nuestros servicios implica:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-blue-700">Aceptación completa de estos términos</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-blue-700">Compromiso de cumplir con las condiciones establecidas</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-blue-700">Reconocimiento de la validez legal de este documento</span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <FileText className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">2. Descripción de Servicios</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Atomic Corporation proporciona servicios industriales especializados para diversas 
                industrias con los más altos estándares de calidad.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-primary-50 rounded-lg p-4">
                  <h3 className="font-semibold text-primary-900 mb-2">Servicios Principales</h3>
                  <ul className="space-y-1 text-primary-700 text-sm">
                    <li>• Mantenimiento industrial</li>
                    <li>• Instalación y montaje</li>
                    <li>• Consultoría técnica</li>
                  </ul>
                </div>
                <div className="bg-accent-50 rounded-lg p-4">
                  <h3 className="font-semibold text-accent-900 mb-2">Servicios Adicionales</h3>
                  <ul className="space-y-1 text-accent-700 text-sm">
                    <li>• Repuestos y accesorios</li>
                    <li>• Inspección y certificación</li>
                    <li>• Capacitación técnica</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Users className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">3. Responsabilidades del Cliente</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Para garantizar la mejor calidad en nuestros servicios, solicitamos a nuestros clientes 
                cumplir con las siguientes responsabilidades:
              </p>
              <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-lg p-6">
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <span className="font-semibold text-gray-900">Información Precisa:</span>
                      <span className="text-gray-700 ml-2">Proporcionar datos exactos y completos sobre sus requerimientos</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <span className="font-semibold text-gray-900">Uso Adecuado:</span>
                      <span className="text-gray-700 ml-2">Utilizar los servicios según las especificaciones técnicas</span>
                    </div>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <span className="font-semibold text-gray-900">Pagos Oportunos:</span>
                      <span className="text-gray-700 ml-2">Realizar los pagos en los plazos acordados</span>
                    </div>
                  </li>
                  </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Shield className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">4. Responsabilidades de Atomic Corporation</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Nos comprometemos a proporcionar servicios de la más alta calidad y cumplir 
                con todas las obligaciones contraídas con nuestros clientes.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-green-50 rounded-lg p-4">
                  <h3 className="font-semibold text-green-900 mb-2">Calidad Garantizada</h3>
                  <ul className="space-y-1 text-green-700 text-sm">
                    <li>• Estándares internacionales</li>
                    <li>• Personal certificado</li>
                    <li>• Equipos modernos</li>
                  </ul>
                </div>
                <div className="bg-blue-50 rounded-lg p-4">
                  <h3 className="font-semibold text-blue-900 mb-2">Compromiso</h3>
                  <ul className="space-y-1 text-blue-700 text-sm">
                    <li>• Cumplimiento de plazos</li>
                    <li>• Confidencialidad total</li>
                    <li>• Soporte continuo</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <AlertCircle className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">5. Propiedad Intelectual</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Todo el contenido del sitio web, incluyendo, pero no limitado a, texto, imágenes, logos,
                y software, es propiedad de Atomic Corporation y está protegido por leyes
                de propiedad intelectual.
              </p>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                <h3 className="font-semibold text-yellow-900 mb-3">Derechos Protegidos:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700">Marcas registradas y logos</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700">Contenido técnico y documentación</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700">Diseños y metodologías propias</span>
                  </li>
                </ul>
                <p className="text-yellow-700 mt-4 text-sm">
                  Está prohibida la reproducción, distribución o modificación sin autorización expresa.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitación de Responsabilidad</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Atomic Corporation no será responsable por daños indirectos, incidentales 
                o consecuentes que surjan del uso de nuestros servicios.
              </p>
              <div className="bg-red-50 rounded-lg p-6">
                <h3 className="font-semibold text-red-900 mb-3">Exclusiones de Responsabilidad:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-red-700">Pérdidas de producción o ganancias</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-red-700">Daños a equipos de terceros</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-red-700">Fuerza mayor o casos fortuitos</span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Terminación del Servicio</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cualquiera de las partes puede terminar este acuerdo bajo ciertas condiciones 
                establecidas en este documento.
              </p>
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 mb-3">Causas de Terminación:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Incumplimiento de los términos establecidos</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Mutuo acuerdo entre las partes</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Casos fortuitos o fuerza mayor</span>
                  </li>
                </ul>
              </div>
            </section>

            <div className="bg-gradient-to-r from-primary-600 to-accent-500 rounded-xl p-8 text-center text-white">
              <h3 className="text-2xl font-bold mb-4">¿Necesitas ayuda con estos términos?</h3>
              <p className="text-blue-100 mb-6">
                Nuestro equipo legal está disponible para resolver cualquier duda que tengas.
              </p>
              <a
                href="mailto:ventas@atomcorporations.com"
                className="inline-flex items-center bg-white text-primary-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                Contactar Asesoría Legal
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsConditions;